module.exports = __webpack_public_path__ + "img/aParty_111523_B.af1e2797.jpg";